import { disallowedCharactersRegex } from './regex'

/**
 * Checks if the given string contains any disallowed characters.
 * @param {string | undefined} string - The string to check for disallowed characters.
 * @returns {boolean} - True if the string is not empty and contains disallowed characters, otherwise false.
 */
export function containsDisallowedCharacters(
  string: string | undefined,
): boolean {
  if (!string || string.trim() === '') return false // Check if the string is empty or contains only whitespace
  return disallowedCharactersRegex.test(string) // Check if the string contains disallowed characters
}
